import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Panel from '../Panel';
import Text from '../Text';
import { Chevron } from '../../icons';
import styles from './ExpandableContainer.css';
var cx = classnames.bind(styles);
export default function ExpandableContainer(_ref) {
  var defaultExpanded = _ref.expanded,
      onExpand = _ref.onExpand,
      onCollapse = _ref.onCollapse,
      children = _ref.children;

  var _React$useState = React.useState(defaultExpanded),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      expanded = _React$useState2[0],
      setExpanded = _React$useState2[1];

  var handleToggle = React.useCallback(function () {
    if (expanded) {
      onCollapse();
    } else {
      onExpand();
    }

    setExpanded(!expanded);
  }, [expanded, onExpand, onCollapse]);
  return React.createElement(React.Fragment, null, React.createElement(Panel, {
    padded: false,
    color: "white",
    className: cx('content', {
      expanded: expanded
    })
  }, children), React.createElement(Panel, {
    padded: false,
    color: "white",
    className: cx('toggle'),
    onClick: handleToggle
  }, React.createElement(Text, {
    className: cx('details')
  }, expanded ? React.createElement(Chevron, {
    className: cx('icon'),
    direction: "up",
    height: "0.8em",
    width: "0.8em"
  }) : React.createElement(Chevron, {
    className: cx('icon'),
    height: "0.8em",
    width: "0.8em"
  }), "\xA0", React.createElement(Text, {
    color: "evergreen"
  }, "Details"))));
}
ExpandableContainer.propTypes = {
  expanded: PropTypes.bool,
  onExpand: PropTypes.func,
  onCollapse: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired
};
ExpandableContainer.defaultProps = {
  expanded: false,
  onExpand: function onExpand() {},
  onCollapse: function onCollapse() {}
};
ExpandableContainer.displayName = 'ExpandableContainer';